import axios from "axios";
import * as actionType from "../../constant/actionType";
export const AdminGetProviderDashboardDetails = (apiData) => {
  return (dispatch) => {
    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/admin/AdminGetProviderDashboardDetails`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      params: apiData,
    };
    
    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};

export const AdminGetWorkerDashboardDetails = (apiData) => {
    return (dispatch) => {
      const config = {
        method: "get",
        url: `${actionType.environment_url}/api/admin/AdminGetWorkerDashboardDetails`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        // params: apiData,
      };
      
      return axios(config)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          return error;
        });
    };
  };
  
  export const AdminGetClientDashboardDetails = (apiData) => {
    return (dispatch) => {
      const config = {
        method: "get",
        url: `${actionType.environment_url}/api/admin/AdminGetClientDashboardDetails`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        params: apiData,
      };
      
      return axios(config)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          return error;
        });
    };
  };